import classNames from 'classnames';
import { AmountWithUnit } from 'components/shared/Amount/Amount';
import { FormattedMessage } from 'components/shared/Intl';
import { FC } from 'react';
import styled from 'styled-components';

export interface UnallocatedAmountProps {
  amount: number;
  currency: string;
  hasWarning: boolean;
  className?: string;
  isDisabled: boolean;
}

export const UnallocatedAmount: FC<UnallocatedAmountProps> = ({
  amount,
  currency,
  hasWarning,
  className,
  isDisabled,
}) => (
  <div className={classNames('', className)}>
    <div>
      <div className="d-flex align-items-center">
        <AmountWithUnit
          unit={currency}
          value={amount}
          isReadOnly
          e2e="unallocated-amount"
          id="tradeAllocation-unallocatedAmount"
          isDisabled={isDisabled}
          className="text-end box-shadow-none"
        />
        <label htmlFor="tradeAllocation-unallocatedAmount" className="text-secondary">
          <FormattedMessage id="form.tradeAllocation.unallocatedAmount" />
        </label>
      </div>
      {hasWarning && !isDisabled && (
        <span className="d-block warning-feedback text-end" data-e2e="unallocated-amount-warning">
          <FormattedMessage id="form.tradeAllocation.warning.unallocatedAmount" />
        </span>
      )}
    </div>
  </div>
);

export const MaxSizedUnallocatedAmount = styled(UnallocatedAmount)`
  max-width: 13rem;
`;
